import { render, staticRenderFns } from "./ReportBase.vue?vue&type=template&id=164cd68d&"
import script from "./ReportBase.vue?vue&type=script&lang=js&"
export * from "./ReportBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports